import {
  CapaInitReport,
  SignatureRegistry,
} from 'components/grid-dx/consult-buttons';
import React from 'react';
import {useGetToken} from '../../../components/hooks';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {useActionButtonStyles} from 'components/grid-dx/styles/actionButtonStyles';

interface ButtonsDataProps {
  cwid: string;
  employee_Nr: number;
  capa_Initial: boolean;
}

export const MAX_ACTION_BUTTONS = 2;

const Buttons = ({cwid, employee_Nr, capa_Initial}: ButtonsDataProps) => {
  const token = useGetToken();
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <SignatureRegistry cwid={cwid} employee_Nr={employee_Nr} token={token} />
      <CapaInitReport
        cwid={cwid}
        employee_Nr={employee_Nr}
        token={token}
        capa_Initial={capa_Initial}
      />
    </div>
  );
};

export default Buttons;
